import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Hero from "components/hero/FullWidthWithImage.js";
import Features from "components/features/ThreeColSimple.js";
import SliderCard from "components/cards/ThreeColSlider.js";
import FAQ from "components/faqs/SimpleWithSideImage.js";
import SimpleContactUs from "components/forms/SimpleContactUs.js";
import Footer from "components/footers/MiniCenteredFooter.js";
import NewProject from "components/forms/TwoColContactUsWithIllustrationFullForm";
import ScrollToTop from "react-scroll-to-top";
import { BsChevronUp } from "react-icons/bs";
import { FaChevronUp } from "react-icons/fa";
import styled from "styled-components";
import { THEME_COLOR } from "config/profile_constants";

const StyledScrollBtn = styled(ScrollToTop)`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50% !important;
  box-shadow: 2px 3px 4px 1px rgb(132 128 177 / 28%);
  color: white;
  background: ${THEME_COLOR};
  transition: all 0.3s;
  &:hover {
    transform: scale(1.03);
    box-shadow: 2px 3px 3px 3px rgba(132 128 177 / 38%);
  }
`;

export default () => (
  <>
    <StyledScrollBtn component={<FaChevronUp />} smooth top={40} />
    <AnimationRevealPage>
      <Hero />
      <Features />
      <SliderCard />
      <FAQ />
      <NewProject />
      <SimpleContactUs />
      <Footer />
    </AnimationRevealPage>
  </>
);
